'use client';

export { CartRecommendations, type CartRecommendationsProps } from './ui/cart-recommendations';
